import _ from 'lodash';
import {
  LTRS_STATUS_AWAITING_SCHEDULE,
  LTRS_STATUS_AWAITING_SERVICE_WINDOW,
  LTRS_STATUS_NEW_PROPERTY,
  LTRS_STATUS_SCHEDULED,
} from '@/store/modules/ltrs/ltrs';

/**
 * @param {array} schedules
 * @returns {boolean}
 */
export const isServiceWindowConfirmed = (schedules) => {
  const pendingConfirmationSchedules = _.filter(
    schedules,
    (schedule) =>
      schedule.status === LTRS_STATUS_NEW_PROPERTY ||
      schedule.status === LTRS_STATUS_AWAITING_SERVICE_WINDOW
  );

  return pendingConfirmationSchedules.length === 0;
};

/**
 * @param {array} schedules
 * @returns {object}
 */
export const getAwaitingSchedule = (schedules) => {
  return _.find(schedules, function(schedule) {
    return schedule.status === LTRS_STATUS_AWAITING_SCHEDULE;
  });
};

/**
 * @param {array} schedules
 * @returns {object}
 */
export const getScheduled = (schedules) => {
  return _.find(schedules, function(schedule) {
    return schedule.status === LTRS_STATUS_SCHEDULED;
  });
};

/**
 * @param {object} awaitingSchedule
 * @param {object} scheduled
 * @returns string
 */
export const getWindowStart = (awaitingSchedule, scheduled) => {
  const startDate =
    (awaitingSchedule && awaitingSchedule.windowStart) || (scheduled && scheduled.startedAt);
  // remove 00:00:00 to avoid drifting a day
  return startDate ? startDate.split(' ')[0] : '';
};

/**
 * @param {object} awaitingSchedule
 * @returns string
 */
export const getWindowEnd = (awaitingSchedule) => {
  const endDate = awaitingSchedule && awaitingSchedule.windowEnd;
  // remove 00:00:00 to avoid drifting a day
  return endDate ? endDate.split(' ')[0] : '';
};

/**
 * @param {object} awaitingSchedule
 * @param {object} scheduled
 * @param {boolean} isLtrsServiceWindowConfirmed
 * @returns string
 */
export const getStatus = (awaitingSchedule, scheduled, isLtrsServiceWindowConfirmed) => {
  return (
    (awaitingSchedule && LTRS_STATUS_AWAITING_SCHEDULE) ||
    (scheduled && LTRS_STATUS_SCHEDULED) ||
    (!isLtrsServiceWindowConfirmed && LTRS_STATUS_AWAITING_SERVICE_WINDOW)
  );
};

/**
 * @returns object
 */
export const getLtrsAttributes = (ltrsGroupedBySchedule, schedule) => {
  const ltrsProvidedByPartner = ltrsGroupedBySchedule
    ? ltrsGroupedBySchedule[schedule.schedule_id]
    : [];

  const scheduled = getScheduled(ltrsProvidedByPartner);

  const awaitingSchedule = getAwaitingSchedule(ltrsProvidedByPartner);

  const isLtrsServiceWindowConfirmed = isServiceWindowConfirmed(ltrsProvidedByPartner);

  const ltrsStatus = getStatus(awaitingSchedule, scheduled, isLtrsServiceWindowConfirmed);
  const isLtrsProvidedByPartner = !!ltrsStatus;

  const ltrsWindowStart = getWindowStart(awaitingSchedule, scheduled);
  const ltrsWindowEnd = getWindowEnd(awaitingSchedule);

  return {
    isLtrsProvidedByPartner: isLtrsProvidedByPartner,
    isLtrsServiceWindowConfirmed: isLtrsServiceWindowConfirmed,
    ltrsWindowStart: ltrsWindowStart,
    ltrsWindowEnd: ltrsWindowEnd,
    ltrsStatus: ltrsStatus,
  };
};
